import React, { useEffect, useState } from "react";
import "./CohortCard.scss";
import { useDispatch, useSelector } from "react-redux";
import exportimages from "../../../../assets/images/exportImages";
import { DeleteCohortModel } from "./DeleteCohortModel";
import { usePermissions } from "../../../../hooks/usePermissions";
import { useSubscription } from "../../../../hooks/useSubscription";
import { PRIVILEGES } from "../../../../utils/privileges";
import { EDIT_MODEL, EditCohortModel } from "./EditCohortModel";
import {
  editCohortSlice,
  setIsEditCohort,
} from "../../../../rtk-query/features/cohort/cohortSlice";
import { Dropdown } from "react-bootstrap";
const CohortCard = ({
  uid,
  title,
  subtitle,
  range,
  institutions,
  avg,
  percentile,
  enableOptions,
  isDefault,
}) => {
  const dispatch = useDispatch();
  const { hasPermission } = usePermissions();
  const { hasSubscription } = useSubscription();
  const [showDeleteCohortModel, setShowShowDeleteCohortModel] = useState(false);
  const [show, setShow] = useState(false);
  const [showEditCohortModel, setShowEditCohortModel] = useState(false);
  const [switchEditModel, setSwitchEditModel] = useState(EDIT_MODEL.EDIT);
  const selectedCohort = useSelector(
    (state) => state?.cohortReducer?.selectedCohort,
  );

  useEffect(() => {
    if (showEditCohortModel) {
      setSwitchEditModel(EDIT_MODEL.EDIT);
    }
  }, [showEditCohortModel]);

  return (
    <>
      <div
        className={`cohort-card cursor-pointer ${uid === selectedCohort?.uid ? "active" : ""}`}
        onMouseLeave={() => setShow(false)}
        onClick={() => setShow(false)}
      >
        <div className="top-section">
          {isDefault && (
            <div
              className="badge"
              style={{
                backgroundColor:
                  uid === selectedCohort?.uid ? "#81A3F5" : "#ffffff00",
                color: uid === selectedCohort?.uid ? "#ffff" : "#667085",
              }}
            >
              Default
            </div>
          )}
          <h4>{title}</h4>
          <p>{subtitle}</p>
          <div className="range">{range}</div>
          {/* <div
            className={`editdetails-icon ${showDeleteButton ? "show" : ""}`}
            onClick={() => {
              setTimeout(() => dispatch(setIsEditCohort(true)), 1000);
              setShowEditCohortModel(true);
            }}
          >
            ED
            <img
              alt="icon"
              src={
                uid === selectedCohort?.uid
                  ? exportimages.list_icon_delete_white
                  : exportimages.list_icon_delete
              }
            />
          </div>
          <div
            className={`edit-icon ${showDeleteButton ? "show" : ""}`}
            onClick={() =>
              setTimeout(() => dispatch(setIsEditCohort(true)), 1000)
            }
          >
            E
            <img
              alt="icon"
              src={
                uid === selectedCohort?.uid
                  ? exportimages.list_icon_delete_white
                  : exportimages.list_icon_delete
              }
            />
          </div> */}
          {/* {hasPermission(PRIVILEGES.DELETE_COHORT) &&
            hasSubscription(PRIVILEGES.DELETE_COHORT) &&
            enableOptions && (
              <div
                className={`delete-icon ${uid === selectedCohort?.uid ? "show" : ""}`}
                // className={`delete-icon show`}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowShowDeleteCohortModel(true);
                }}
              >
                <img
                  alt="icon"
                  src={
                    uid === selectedCohort?.uid
                      ? exportimages.list_icon_delete_white
                      : exportimages.list_icon_delete
                  }
                />
              </div>
            )} */}

          {hasPermission(PRIVILEGES.EDIT_COHORT) &&
            hasSubscription(PRIVILEGES.EDIT_COHORT) &&
            enableOptions && (
              <div
                className={`edit-icon ${uid === selectedCohort?.uid ? "show" : ""}`}
                onMouseEnter={() => setShow(true)}
                // className={`edit-icon show`}
                // onClick={() => setShowShowDeleteCohortModel(true)}
              >
                <Dropdown show={show}>
                  <Dropdown.Toggle id="dropdown-basic">
                    <img
                      alt="icon"
                      src={
                        uid === selectedCohort?.uid
                          ? exportimages.list_icon_edit_solid_white
                          : exportimages.list_icon_edit_solid
                      }
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    style={{
                      marginTop: "0.5rem",
                      borderRadius: "6px 0 6px 6px",
                    }}
                  >
                    {hasPermission(PRIVILEGES.DELETE_COHORT) &&
                      hasSubscription(PRIVILEGES.DELETE_COHORT) && (
                        <>
                          <Dropdown.Item
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              dispatch(setIsEditCohort(true));
                            }}
                          >
                            Edit Cohort List
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              dispatch(setIsEditCohort(true));
                              setShowEditCohortModel(true);
                            }}
                          >
                            Edit Cohort Details
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              dispatch(
                                editCohortSlice({
                                  cohortTitle: title,
                                  cohortDesc: subtitle,
                                  uid: uid,
                                  isDefault: isDefault,
                                }),
                              );
                            }}
                          >
                            {isDefault
                              ? "Remove as default"
                              : "Mark as default"}
                          </Dropdown.Item>
                        </>
                      )}

                    {hasPermission(PRIVILEGES.DELETE_COHORT) &&
                      hasSubscription(PRIVILEGES.DELETE_COHORT) &&
                      enableOptions && (
                        <Dropdown.Item
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setShowShowDeleteCohortModel(true);
                          }}
                        >
                          Delete Cohort
                        </Dropdown.Item>
                      )}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
        </div>
        <div className="bottom-section">
          <div className="stats">
            <div>
              <label>Institutions</label>
              <span>{institutions}</span>
            </div>
            <div>
              <label>Cohort Average</label>
              <span>{avg}</span>
            </div>
            <div>
              <label>Percentile</label>
              <span>{percentile}</span>
            </div>
          </div>
        </div>
      </div>
      <DeleteCohortModel
        show={showDeleteCohortModel}
        onHide={() => setShowShowDeleteCohortModel(false)}
        uid={uid}
      />

      <EditCohortModel
        show={showEditCohortModel}
        onHide={() => setShowEditCohortModel(false)}
        uid={uid}
        title={title}
        subtitle={subtitle}
        switchEditModel={switchEditModel}
        setSwitchEditModel={setSwitchEditModel}
      />
    </>
  );
};

export default CohortCard;
